export const FieldTitle = (props) => (
  <div className="mt-4 text-blue-500">{props.children}</div>
);
